import React, { useState, useEffect, useContext } from 'react';
import { Modal } from 'antd';
import ValueContext from './Context';
import './Header.css';

export default function Header() {
  const {
    activeMenu,
    locale,
    changeactiveMenu,
    getText,
  } = useContext(ValueContext);
  const [menu, setmenu] = useState('N');
  const [text, settext] = useState(getText());
  const [showModal, setshowModal] = useState(false);

  useEffect(() => {
    changeactiveMenu(menu);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menu]);

  useEffect(() => {
    settext(getText());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);

  return (
    <div className='HeaderGrid'>
      <span className='NaviCont'>
        <span
          onClick={() => setmenu('N')}
          className={activeMenu === 'N' ? 'SelectedMenu Navi' : 'Navi'}>
          {text.Header.Navi}
        </span>
      </span>
      <span className='ÜbersichtCont'>
        <span
          onClick={() => setmenu('Ü')}
          className={activeMenu === 'Ü' ? 'SelectedMenu Übersicht' : 'Übersicht'}>
          {text.Header.Over}
        </span>
      </span>
      <span className='MontageCont'>
        <span
          onClick={() => setshowModal(true)}
          className={activeMenu === 'M' ? 'SelectedMenu Montage' : 'Montage'}>
          {text.Header.Assembly}
        </span>
      </span>
      <Modal
        title={text.Header.Assembly}
        visible={showModal}
        onCancel={() => setshowModal(false)}
        footer={null}>
        <p>
          <a href='https://www.rk-rose-krieger.com/fileadmin/catalogue/manuals_lineartechnik/99452_multicontrol_II.pdf' target='_blank' rel='noopener noreferrer'>
            {text.Header.Assembly} 2-0 {text.Header.ModalSW} 4.0/4.1
          </a>
        </p>
        <p>
          <a href='https://www.rk-rose-krieger.com/fileadmin/catalogue/manuals_lineartechnik/mc/99452_multicontrol_II_1.3_AR.pdf' target='_blank' rel='noopener noreferrer'>
            {text.Header.Assembly} 1-3 {text.Header.ModalSW} 3.2
          </a>
        </p>
      </Modal>
    </div>
  );
}
